import type {
  Item,
  ItemCategory,
  Warehouse,
  StockBalance,
  StockEntry,
} from '../types';

// 품목 카테고리 - 농산물 박스 공장
export const categories: ItemCategory[] = [
  { id: 'finished', name: '완제품 박스', itemCount: 10 },
  { id: 'corrugated', name: '골판지 원단', itemCount: 6 },
  { id: 'rawpaper', name: '원지/라이너', itemCount: 5 },
  { id: 'supplies', name: '부자재', itemCount: 5 },
];

// 품목 목록 - 농산물 박스 공장
export const items: Item[] = [
  // 완제품 박스
  {
    id: 'item-001',
    code: 'BOX-A10',
    name: '사과박스 10kg',
    category: 'finished',
    unit: 'EA',
    price: 2800,
    cost: 1850,
    minStock: 500,
    maxStock: 5000,
    barcode: '8801234500001',
    description: '사과 10kg용 골판지 박스 (E골)',
    isActive: true,
    createdAt: '2025-01-01',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-002',
    code: 'BOX-A05',
    name: '사과박스 5kg',
    category: 'finished',
    unit: 'EA',
    price: 2200,
    cost: 1450,
    minStock: 500,
    maxStock: 5000,
    barcode: '8801234500002',
    description: '사과 5kg용 골판지 박스 (E골)',
    isActive: true,
    createdAt: '2025-01-01',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-003',
    code: 'BOX-P15',
    name: '배박스 15kg',
    category: 'finished',
    unit: 'EA',
    price: 3500,
    cost: 2300,
    minStock: 300,
    maxStock: 3000,
    barcode: '8801234500003',
    description: '배 15kg용 골판지 박스 (BC골)',
    isActive: true,
    createdAt: '2025-01-02',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-004',
    code: 'BOX-G05',
    name: '포도박스 5kg',
    category: 'finished',
    unit: 'EA',
    price: 2500,
    cost: 1650,
    minStock: 400,
    maxStock: 4000,
    barcode: '8801234500004',
    description: '포도 5kg용 골판지 박스 (E골)',
    isActive: true,
    createdAt: '2025-01-02',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-005',
    code: 'BOX-T10',
    name: '토마토박스 10kg',
    category: 'finished',
    unit: 'EA',
    price: 2600,
    cost: 1700,
    minStock: 400,
    maxStock: 4000,
    barcode: '8801234500005',
    description: '토마토 10kg용 골판지 박스 (B골)',
    isActive: true,
    createdAt: '2025-01-03',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-006',
    code: 'BOX-C20',
    name: '감귤박스 20kg',
    category: 'finished',
    unit: 'EA',
    price: 3200,
    cost: 2100,
    minStock: 300,
    maxStock: 3000,
    barcode: '8801234500006',
    description: '감귤 20kg용 골판지 박스 (BC골)',
    isActive: true,
    createdAt: '2025-01-03',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-007',
    code: 'BOX-W05',
    name: '수박박스 1통',
    category: 'finished',
    unit: 'EA',
    price: 1800,
    cost: 1200,
    minStock: 300,
    maxStock: 3000,
    barcode: '8801234500007',
    description: '수박 1통용 골판지 박스 (B골)',
    isActive: true,
    createdAt: '2025-01-04',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-008',
    code: 'BOX-S03',
    name: '딸기박스 3kg',
    category: 'finished',
    unit: 'EA',
    price: 2000,
    cost: 1300,
    minStock: 500,
    maxStock: 5000,
    barcode: '8801234500008',
    description: '딸기 3kg용 골판지 박스 (E골)',
    isActive: true,
    createdAt: '2025-01-04',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-009',
    code: 'BOX-V10',
    name: '채소박스 10kg',
    category: 'finished',
    unit: 'EA',
    price: 2400,
    cost: 1580,
    minStock: 400,
    maxStock: 4000,
    barcode: '8801234500009',
    description: '채소용 골판지 박스 (B골)',
    isActive: true,
    createdAt: '2025-01-05',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-010',
    code: 'BOX-M05',
    name: '버섯박스 5kg',
    category: 'finished',
    unit: 'EA',
    price: 2100,
    cost: 1380,
    minStock: 300,
    maxStock: 3000,
    barcode: '8801234500010',
    description: '버섯 5kg용 골판지 박스 (E골)',
    isActive: true,
    createdAt: '2025-01-05',
    updatedAt: '2025-01-28',
  },
  // 골판지 원단
  {
    id: 'item-011',
    code: 'CB-E120',
    name: 'E골 골판지 120cm',
    category: 'corrugated',
    unit: 'm²',
    price: 850,
    cost: 650,
    minStock: 1000,
    maxStock: 10000,
    barcode: '8801234510011',
    description: 'E골 골판지 원단 120cm 폭',
    isActive: true,
    createdAt: '2025-01-01',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-012',
    code: 'CB-B120',
    name: 'B골 골판지 120cm',
    category: 'corrugated',
    unit: 'm²',
    price: 920,
    cost: 700,
    minStock: 1000,
    maxStock: 10000,
    barcode: '8801234510012',
    description: 'B골 골판지 원단 120cm 폭',
    isActive: true,
    createdAt: '2025-01-01',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-013',
    code: 'CB-BC120',
    name: 'BC골 골판지 120cm',
    category: 'corrugated',
    unit: 'm²',
    price: 1100,
    cost: 850,
    minStock: 800,
    maxStock: 8000,
    barcode: '8801234510013',
    description: 'BC 이중골 골판지 원단 120cm 폭',
    isActive: true,
    createdAt: '2025-01-02',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-014',
    code: 'CB-E180',
    name: 'E골 골판지 180cm',
    category: 'corrugated',
    unit: 'm²',
    price: 1200,
    cost: 920,
    minStock: 500,
    maxStock: 5000,
    barcode: '8801234510014',
    description: 'E골 골판지 원단 180cm 폭',
    isActive: true,
    createdAt: '2025-01-02',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-015',
    code: 'CB-B180',
    name: 'B골 골판지 180cm',
    category: 'corrugated',
    unit: 'm²',
    price: 1350,
    cost: 1050,
    minStock: 500,
    maxStock: 5000,
    barcode: '8801234510015',
    description: 'B골 골판지 원단 180cm 폭',
    isActive: true,
    createdAt: '2025-01-03',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-016',
    code: 'CB-BC180',
    name: 'BC골 골판지 180cm',
    category: 'corrugated',
    unit: 'm²',
    price: 1580,
    cost: 1220,
    minStock: 400,
    maxStock: 4000,
    barcode: '8801234510016',
    description: 'BC 이중골 골판지 원단 180cm 폭',
    isActive: true,
    createdAt: '2025-01-03',
    updatedAt: '2025-01-28',
  },
  // 원지/라이너
  {
    id: 'item-017',
    code: 'LN-K180',
    name: 'K라이너 180g',
    category: 'rawpaper',
    unit: 'kg',
    price: 680,
    cost: 520,
    minStock: 2000,
    maxStock: 20000,
    barcode: '8801234520017',
    description: 'K급 라이너 180g/m²',
    isActive: true,
    createdAt: '2025-01-01',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-018',
    code: 'LN-K200',
    name: 'K라이너 200g',
    category: 'rawpaper',
    unit: 'kg',
    price: 750,
    cost: 580,
    minStock: 2000,
    maxStock: 20000,
    barcode: '8801234520018',
    description: 'K급 라이너 200g/m²',
    isActive: true,
    createdAt: '2025-01-02',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-019',
    code: 'CM-127',
    name: '골심지 127g',
    category: 'rawpaper',
    unit: 'kg',
    price: 480,
    cost: 380,
    minStock: 3000,
    maxStock: 30000,
    barcode: '8801234520019',
    description: '골심지 127g/m²',
    isActive: true,
    createdAt: '2025-01-02',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-020',
    code: 'LN-W180',
    name: '백라이너 180g',
    category: 'rawpaper',
    unit: 'kg',
    price: 880,
    cost: 680,
    minStock: 1000,
    maxStock: 10000,
    barcode: '8801234520020',
    description: '백색 라이너 180g/m²',
    isActive: true,
    createdAt: '2025-01-03',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-021',
    code: 'LN-SC200',
    name: 'SC급 라이너 200g',
    category: 'rawpaper',
    unit: 'kg',
    price: 620,
    cost: 480,
    minStock: 2000,
    maxStock: 20000,
    barcode: '8801234520021',
    description: 'SC급 라이너 200g/m²',
    isActive: true,
    createdAt: '2025-01-03',
    updatedAt: '2025-01-28',
  },
  // 부자재
  {
    id: 'item-022',
    code: 'SUP-TAPE',
    name: '포장테이프',
    category: 'supplies',
    unit: '롤',
    price: 3500,
    cost: 2200,
    minStock: 100,
    maxStock: 1000,
    barcode: '8801234530022',
    description: '박스 포장용 테이프 48mm x 100m',
    isActive: true,
    createdAt: '2025-01-04',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-023',
    code: 'SUP-STRAP',
    name: 'PP밴드',
    category: 'supplies',
    unit: '롤',
    price: 28000,
    cost: 19000,
    minStock: 50,
    maxStock: 500,
    barcode: '8801234530023',
    description: 'PP밴드 15mm x 1000m',
    isActive: true,
    createdAt: '2025-01-04',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-024',
    code: 'SUP-GLUE',
    name: '전분 풀',
    category: 'supplies',
    unit: 'kg',
    price: 1800,
    cost: 1200,
    minStock: 500,
    maxStock: 5000,
    barcode: '8801234530024',
    description: '골판지 접착용 전분 풀',
    isActive: true,
    createdAt: '2025-01-05',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-025',
    code: 'SUP-INK',
    name: '인쇄 잉크',
    category: 'supplies',
    unit: 'kg',
    price: 15000,
    cost: 11000,
    minStock: 50,
    maxStock: 500,
    barcode: '8801234530025',
    description: '플렉소 인쇄용 수성 잉크',
    isActive: true,
    createdAt: '2025-01-05',
    updatedAt: '2025-01-28',
  },
  {
    id: 'item-026',
    code: 'SUP-PALLET',
    name: '목재 파레트',
    category: 'supplies',
    unit: 'EA',
    price: 15000,
    cost: 10000,
    minStock: 30,
    maxStock: 300,
    barcode: '8801234530026',
    description: '110cm x 110cm 목재 파레트',
    isActive: true,
    createdAt: '2025-01-06',
    updatedAt: '2025-01-28',
  },
];

// 창고 목록
export const warehouses: Warehouse[] = [
  {
    id: 'wh-001',
    code: 'WH-MAIN',
    name: '본사 공장 창고',
    address: '경기도 이천시 신둔면 산업단지로 123',
    capacity: 15000,
    usedCapacity: 9500,
    isActive: true,
    manager: '김창고',
  },
  {
    id: 'wh-002',
    code: 'WH-RAW',
    name: '원자재 창고',
    address: '경기도 이천시 신둔면 산업단지로 125',
    capacity: 8000,
    usedCapacity: 5200,
    isActive: true,
    manager: '이원자재',
  },
  {
    id: 'wh-003',
    code: 'WH-FINISH',
    name: '완제품 창고',
    address: '경기도 이천시 신둔면 산업단지로 127',
    capacity: 12000,
    usedCapacity: 7800,
    isActive: true,
    manager: '박완제품',
  },
];

// 재고 현황
export const stockBalances: StockBalance[] = [
  // 본사 공장 창고 - 완제품
  { id: 'sb-001', itemId: 'item-001', itemCode: 'BOX-A10', itemName: '사과박스 10kg', warehouseId: 'wh-003', warehouseName: '완제품 창고', quantity: 2500, reservedQuantity: 300, availableQuantity: 2200, unit: 'EA', lastUpdated: '2025-01-28T10:00:00' },
  { id: 'sb-002', itemId: 'item-002', itemCode: 'BOX-A05', itemName: '사과박스 5kg', warehouseId: 'wh-003', warehouseName: '완제품 창고', quantity: 1800, reservedQuantity: 200, availableQuantity: 1600, unit: 'EA', lastUpdated: '2025-01-28T10:00:00' },
  { id: 'sb-003', itemId: 'item-003', itemCode: 'BOX-P15', itemName: '배박스 15kg', warehouseId: 'wh-003', warehouseName: '완제품 창고', quantity: 850, reservedQuantity: 100, availableQuantity: 750, unit: 'EA', lastUpdated: '2025-01-28T10:00:00' },
  { id: 'sb-004', itemId: 'item-004', itemCode: 'BOX-G05', itemName: '포도박스 5kg', warehouseId: 'wh-003', warehouseName: '완제품 창고', quantity: 1200, reservedQuantity: 150, availableQuantity: 1050, unit: 'EA', lastUpdated: '2025-01-28T10:00:00' },
  { id: 'sb-005', itemId: 'item-005', itemCode: 'BOX-T10', itemName: '토마토박스 10kg', warehouseId: 'wh-003', warehouseName: '완제품 창고', quantity: 320, reservedQuantity: 50, availableQuantity: 270, unit: 'EA', lastUpdated: '2025-01-28T10:00:00' },
  { id: 'sb-006', itemId: 'item-006', itemCode: 'BOX-C20', itemName: '감귤박스 20kg', warehouseId: 'wh-003', warehouseName: '완제품 창고', quantity: 2800, reservedQuantity: 500, availableQuantity: 2300, unit: 'EA', lastUpdated: '2025-01-28T10:00:00' },
  { id: 'sb-007', itemId: 'item-008', itemCode: 'BOX-S03', itemName: '딸기박스 3kg', warehouseId: 'wh-003', warehouseName: '완제품 창고', quantity: 3500, reservedQuantity: 800, availableQuantity: 2700, unit: 'EA', lastUpdated: '2025-01-28T10:00:00' },
  { id: 'sb-008', itemId: 'item-009', itemCode: 'BOX-V10', itemName: '채소박스 10kg', warehouseId: 'wh-003', warehouseName: '완제품 창고', quantity: 1500, reservedQuantity: 200, availableQuantity: 1300, unit: 'EA', lastUpdated: '2025-01-28T10:00:00' },

  // 원자재 창고 - 골판지/원지
  { id: 'sb-009', itemId: 'item-011', itemCode: 'CB-E120', itemName: 'E골 골판지 120cm', warehouseId: 'wh-002', warehouseName: '원자재 창고', quantity: 5500, reservedQuantity: 500, availableQuantity: 5000, unit: 'm²', lastUpdated: '2025-01-28T09:00:00' },
  { id: 'sb-010', itemId: 'item-012', itemCode: 'CB-B120', itemName: 'B골 골판지 120cm', warehouseId: 'wh-002', warehouseName: '원자재 창고', quantity: 4200, reservedQuantity: 300, availableQuantity: 3900, unit: 'm²', lastUpdated: '2025-01-28T09:00:00' },
  { id: 'sb-011', itemId: 'item-013', itemCode: 'CB-BC120', itemName: 'BC골 골판지 120cm', warehouseId: 'wh-002', warehouseName: '원자재 창고', quantity: 2800, reservedQuantity: 200, availableQuantity: 2600, unit: 'm²', lastUpdated: '2025-01-28T09:00:00' },
  { id: 'sb-012', itemId: 'item-017', itemCode: 'LN-K180', itemName: 'K라이너 180g', warehouseId: 'wh-002', warehouseName: '원자재 창고', quantity: 8500, reservedQuantity: 1000, availableQuantity: 7500, unit: 'kg', lastUpdated: '2025-01-28T09:00:00' },
  { id: 'sb-013', itemId: 'item-019', itemCode: 'CM-127', itemName: '골심지 127g', warehouseId: 'wh-002', warehouseName: '원자재 창고', quantity: 12000, reservedQuantity: 1500, availableQuantity: 10500, unit: 'kg', lastUpdated: '2025-01-28T09:00:00' },

  // 본사 공장 창고 - 부자재
  { id: 'sb-014', itemId: 'item-022', itemCode: 'SUP-TAPE', itemName: '포장테이프', warehouseId: 'wh-001', warehouseName: '본사 공장 창고', quantity: 350, reservedQuantity: 50, availableQuantity: 300, unit: '롤', lastUpdated: '2025-01-28T08:00:00' },
  { id: 'sb-015', itemId: 'item-024', itemCode: 'SUP-GLUE', itemName: '전분 풀', warehouseId: 'wh-001', warehouseName: '본사 공장 창고', quantity: 2200, reservedQuantity: 300, availableQuantity: 1900, unit: 'kg', lastUpdated: '2025-01-28T08:00:00' },
  { id: 'sb-016', itemId: 'item-025', itemCode: 'SUP-INK', itemName: '인쇄 잉크', warehouseId: 'wh-001', warehouseName: '본사 공장 창고', quantity: 180, reservedQuantity: 30, availableQuantity: 150, unit: 'kg', lastUpdated: '2025-01-28T08:00:00' },
];

// 재고 이동 내역
export const stockEntries: StockEntry[] = [
  {
    id: 'se-001',
    entryNo: 'RCV-20250128-0001',
    type: 'receive',
    itemId: 'item-017',
    itemCode: 'LN-K180',
    itemName: 'K라이너 180g',
    quantity: 5000,
    unit: 'kg',
    toWarehouseId: 'wh-002',
    toWarehouseName: '원자재 창고',
    reason: '정기 입고',
    reference: 'PO-2025-001',
    status: 'completed',
    createdBy: '홍길동',
    createdAt: '2025-01-28T09:00:00',
    completedAt: '2025-01-28T09:15:00',
  },
  {
    id: 'se-002',
    entryNo: 'ISS-20250128-0001',
    type: 'issue',
    itemId: 'item-001',
    itemCode: 'BOX-A10',
    itemName: '사과박스 10kg',
    quantity: 500,
    unit: 'EA',
    fromWarehouseId: 'wh-003',
    fromWarehouseName: '완제품 창고',
    reason: '판매 출고',
    reference: 'SO-2025-003',
    status: 'completed',
    createdBy: '김철수',
    createdAt: '2025-01-28T10:30:00',
    completedAt: '2025-01-28T10:45:00',
  },
  {
    id: 'se-003',
    entryNo: 'TRF-20250128-0001',
    type: 'transfer',
    itemId: 'item-011',
    itemCode: 'CB-E120',
    itemName: 'E골 골판지 120cm',
    quantity: 1000,
    unit: 'm²',
    fromWarehouseId: 'wh-002',
    fromWarehouseName: '원자재 창고',
    toWarehouseId: 'wh-001',
    toWarehouseName: '본사 공장 창고',
    reason: '생산 투입',
    status: 'completed',
    createdBy: '박물류',
    createdAt: '2025-01-28T11:00:00',
    completedAt: '2025-01-28T11:30:00',
  },
  {
    id: 'se-004',
    entryNo: 'MFG-20250128-0001',
    type: 'receive',
    itemId: 'item-002',
    itemCode: 'BOX-A05',
    itemName: '사과박스 5kg',
    quantity: 1000,
    unit: 'EA',
    toWarehouseId: 'wh-003',
    toWarehouseName: '완제품 창고',
    reason: '생산 완료 입고',
    reference: 'WO-2025-005',
    status: 'completed',
    createdBy: '이생산',
    createdAt: '2025-01-28T14:00:00',
    completedAt: '2025-01-28T14:30:00',
  },
  {
    id: 'se-005',
    entryNo: 'ADJ-20250128-0001',
    type: 'adjustment',
    itemId: 'item-024',
    itemCode: 'SUP-GLUE',
    itemName: '전분 풀',
    quantity: -50,
    unit: 'kg',
    fromWarehouseId: 'wh-001',
    fromWarehouseName: '본사 공장 창고',
    reason: '재고 실사 조정 (손실)',
    status: 'completed',
    createdBy: '이관리',
    createdAt: '2025-01-28T15:00:00',
    completedAt: '2025-01-28T15:10:00',
  },
  {
    id: 'se-006',
    entryNo: 'RCV-20250127-0003',
    type: 'receive',
    itemId: 'item-019',
    itemCode: 'CM-127',
    itemName: '골심지 127g',
    quantity: 8000,
    unit: 'kg',
    toWarehouseId: 'wh-002',
    toWarehouseName: '원자재 창고',
    reason: '긴급 입고',
    reference: 'PO-2025-005',
    status: 'completed',
    createdBy: '홍길동',
    createdAt: '2025-01-27T16:00:00',
    completedAt: '2025-01-27T16:30:00',
  },
  {
    id: 'se-007',
    entryNo: 'ISS-20250128-0002',
    type: 'issue',
    itemId: 'item-006',
    itemCode: 'BOX-C20',
    itemName: '감귤박스 20kg',
    quantity: 1500,
    unit: 'EA',
    fromWarehouseId: 'wh-003',
    fromWarehouseName: '완제품 창고',
    reason: '제주농협 출고',
    reference: 'SO-2025-008',
    status: 'submitted',
    createdBy: '김철수',
    createdAt: '2025-01-28T16:00:00',
  },
];

// 헬퍼 함수들
export function getItemById(id: string): Item | undefined {
  return items.find((item) => item.id === id);
}

export function getWarehouseById(id: string): Warehouse | undefined {
  return warehouses.find((wh) => wh.id === id);
}

export function getStockByWarehouse(warehouseId: string): StockBalance[] {
  return stockBalances.filter((sb) => sb.warehouseId === warehouseId);
}

export function getStockByItem(itemId: string): StockBalance[] {
  return stockBalances.filter((sb) => sb.itemId === itemId);
}

export function getTotalStock(itemId: string): number {
  return stockBalances
    .filter((sb) => sb.itemId === itemId)
    .reduce((sum, sb) => sum + sb.quantity, 0);
}

export function getLowStockItems(): StockBalance[] {
  return stockBalances.filter((sb) => {
    const item = getItemById(sb.itemId);
    return item && sb.quantity < item.minStock;
  });
}

export function getOutOfStockItems(): StockBalance[] {
  return stockBalances.filter((sb) => sb.quantity === 0);
}
